/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { IBuilderForMapPresenterSchema } from '../../entities/builder/BuilderForMapPresenterSchema';
import { ICommunicationSetSchema } from '../../entities/communication/CommunicationSetSchema';
import { IFeatureSchema } from '../../entities/feature/FeatureSchema';
import { IGallerySchema } from '../../entities/gallery/GallerySchema';
import { IGeoSchema } from '../../entities/geo/GeoSchema';
import { INeighbourhoodSchema } from '../../entities/neighbourhood/NeighbourhoodSchema';
import { INewobjectCategorySetForMapPresenterSchema } from '../../entities/newobject_category/NewobjectCategorySetForMapPresenterSchema';
import { ISeoDataSchema } from '../../entities/seo/SeoDataSchema';
import { IVideoSchema } from '../../entities/video/VideoSchema';

export type TGetVillageForMapModel = IModel<IGetVillageForMapRequest, TGetVillageForMapResponse>;

export interface IGetVillageForMapRequest {
  /** Идентификатор объекта в БД **/
  id?: number | null;
}

export type TGetVillageForMapResponse = IGetVillageForMapResponse200 | IGetVillageForMapResponse400;

export interface IGetVillageForMapResponse200 extends IModelResponse<IGetVillageForMapResponse> {
  statusCode: 200;
}

export interface IGetVillageForMapResponse400 extends IModelResponse<IGetVillageForMapResponseError> {
  statusCode: 400;
}

export interface IGetVillageForMapResponse {
  /** Площадь, га **/
  areaHectare?: number | null;
  /** Застройщик **/
  builder: IBuilderForMapPresenterSchema;
  /** Коммуникации **/
  communicationSet?: ICommunicationSetSchema | null;
  /** Оценка качества контента КП **/
  contentScore?: number | null;
  /** Описание **/
  description?: string | null;
  /** Отображать ли телефон застройщика **/
  displayBuilderPhone?: boolean | null;
  /** undefined **/
  featureList?: IFeatureSchema[] | null;
  /** Месяц сдачи до **/
  finishMonthMax?: EFinishMonthMax | null;
  /** Месяц сдачи от **/
  finishMonthMin?: EFinishMonthMin | null;
  /** Квартал сдачи до **/
  finishQuarterMax?: EFinishQuarterMax | null;
  /** Квартал сдачи от **/
  finishQuarterMin?: EFinishQuarterMin | null;
  /** Год сдачи до **/
  finishYearMax?: number | null;
  /** Год сдачи от **/
  finishYearMin?: number | null;
  /** Этажность, до **/
  floorCountMax?: number | null;
  /** Этажность, от **/
  floorCountMin?: number | null;
  /** Полный адрес КП в виде текста **/
  fullAddress?: string | null;
  /** Галерея **/
  gallery?: IGallerySchema | null;
  /** URL изображения генплана **/
  generalPlanUrl?: string | null;
  /** Информация о географическом расположении **/
  geo?: IGeoSchema | null;
  /** Скрывать цену КП **/
  hidePrice?: boolean | null;
  /** Материалы домов в КП **/
  houseMaterialList?: EHouseMaterialList[] | null;
  /** ID **/
  id: number;
  /** URL изображения **/
  imageUrl: string;
  /** Инфраструктура **/
  infrastructureList?: EInfrastructureList[] | null;
  /** Статус КП "Премиум" **/
  isPremium?: boolean | null;
  /** Флаг скрытия КП из выдачи **/
  isVisible?: boolean | null;
  /** Название населённого пункта в предложном падеже **/
  locationNamePrepositional?: string | null;
  /** Название **/
  name: string;
  /** undefined **/
  neighbourhoodList?: INeighbourhoodSchema[] | null;
  /** Типы объектов КП **/
  newobjectCategorySet?: INewobjectCategorySetForMapPresenterSchema | null;
  /** Цена до, руб **/
  priceMax?: number | null;
  /** Цена от, руб **/
  priceMin?: number | null;
  /** Статус готовности **/
  readyStatus?: EReadyStatus | null;
  /** Регион **/
  regionId?: number | null;
  /** Статус продаж **/
  saleStatus?: ESaleStatus | null;
  /** Карточка КП **/
  seo?: ISeoDataSchema | null;
  /** URL сайта **/
  siteUrl?: string | null;
  /** URL миниатюр изображений **/
  thumbnailList: string[];
  /** Общий статус **/
  totalStatus?: ETotalStatus | null;
  /** undefined **/
  videoList?: IVideoSchema[] | null;
  /** Класс **/
  villageClass?: EVillageClass | null;
}

export interface IGetVillageForMapResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IGetVillageForMapResponse | IGetVillageForMapResponseError;

export enum EFinishMonthMax {
  /** Апрель **/
  April = 'april',
  /** Август **/
  August = 'august',
  /** Декабрь **/
  December = 'december',
  /** Февраль **/
  February = 'february',
  /** Январь **/
  January = 'january',
  /** Июль **/
  July = 'july',
  /** Июнь **/
  June = 'june',
  /** Март **/
  March = 'march',
  /** Май **/
  May = 'may',
  /** Ноябрь **/
  November = 'november',
  /** Октябрь **/
  October = 'october',
  /** Сентябрь **/
  September = 'september',
}

export enum EFinishMonthMin {
  /** Апрель **/
  April = 'april',
  /** Август **/
  August = 'august',
  /** Декабрь **/
  December = 'december',
  /** Февраль **/
  February = 'february',
  /** Январь **/
  January = 'january',
  /** Июль **/
  July = 'july',
  /** Июнь **/
  June = 'june',
  /** Март **/
  March = 'march',
  /** Май **/
  May = 'may',
  /** Ноябрь **/
  November = 'november',
  /** Октябрь **/
  October = 'october',
  /** Сентябрь **/
  September = 'september',
}

export enum EFinishQuarterMax {
  /** I **/
  First = 'first',
  /** IV **/
  Fourth = 'fourth',
  /** II **/
  Second = 'second',
  /** III **/
  Third = 'third',
}

export enum EFinishQuarterMin {
  /** I **/
  First = 'first',
  /** IV **/
  Fourth = 'fourth',
  /** II **/
  Second = 'second',
  /** III **/
  Third = 'third',
}

export enum EHouseMaterialList {
  /** газобетонный блок **/
  AerocreteBlock = 'aerocreteBlock',
  /** блочный **/
  Block = 'block',
  /** щитовой **/
  Boards = 'boards',
  /** кирпичный **/
  Brick = 'brick',
  /** custom **/
  Custom = 'custom',
  /** пенобетонный блок **/
  FoamConcreteBlock = 'foamConcreteBlock',
  /** газосиликатный блок **/
  GasSilicateBlock = 'gasSilicateBlock',
  /** монолитный **/
  Monolith = 'monolith',
  /** монолитно кирпичный **/
  MonolithBrick = 'monolithBrick',
  /** не указано **/
  None = 'none',
  /** старый фонд **/
  Old = 'old',
  /** панельный **/
  Panel = 'panel',
  /** сталинский **/
  Stalin = 'stalin',
  /** каркасный **/
  Wireframe = 'wireframe',
  /** деревянный **/
  Wood = 'wood',
}

export enum EInfrastructureList {
  /** Пропускная система **/
  Access = 'access',
  /** Автосервис **/
  CarService = 'carService',
  /** Церковь **/
  Church = 'church',
  /** Кино **/
  Cinema = 'cinema',
  /** Медпункт **/
  Clinic = 'clinic',
  /** Коммерческий объект **/
  Commercial = 'commercial',
  /** Консьерж **/
  Concierge = 'concierge',
  /** Площадки для выгула собак **/
  DogsWalking = 'dogsWalking',
  /** Пожарная служба **/
  Fire = 'fire',
  /** Фитнес-центр **/
  Fitness = 'fitness',
  /** Лесная зона **/
  Forest = 'forest',
  /** АЗС **/
  GasStation = 'gasStation',
  /** Охраняемая парковка **/
  GuardedParking = 'guardedParking',
  /** Залив **/
  Gulf = 'gulf',
  /** Больница **/
  Hospital = 'hospital',
  /** Институт **/
  Institute = 'institute',
  /** Детский сад **/
  Kindergarten = 'kindergarten',
  /** Озеро **/
  Lake = 'lake',
  /** Музей **/
  Museum = 'museum',
  /** Офис **/
  Office = 'office',
  /** Парковая зона **/
  Park = 'park',
  /** Парковка **/
  Parking = 'parking',
  /** Огороженный периметр **/
  Perimeter = 'perimeter',
  /** Аптека **/
  Pharmacy = 'pharmacy',
  /** Детская площадка **/
  Playground = 'playground',
  /** Полиция **/
  Police = 'police',
  /** Поликлиника **/
  Polyclinic = 'polyclinic',
  /** Пруд **/
  Pond = 'pond',
  /** Бассейн **/
  Pool = 'pool',
  /** Заповедник **/
  Reserve = 'reserve',
  /** Курортная зона **/
  Resort = 'resort',
  /** Место для отдыха **/
  Rest = 'rest',
  /** Ресторан **/
  Restaurant = 'restaurant',
  /** Река **/
  River = 'river',
  /** Школа **/
  School = 'school',
  /** Круглосуточная охрана **/
  Security = 'security',
  /** Пункт бытового самообслуживания **/
  SelfService = 'selfService',
  /** Магазин **/
  Shop = 'shop',
  /** Торговый центр **/
  ShoppingCenter = 'shoppingCenter',
  /** Сигнализация **/
  Signaling = 'signaling',
  /** SPA-центр **/
  Spa = 'spa',
  /** Спортивная площадка **/
  SportsGround = 'sportsGround',
  /** Площадь **/
  Square = 'square',
  /** Стадион **/
  Stadium = 'stadium',
  /** Студия **/
  Studio = 'studio',
  /** Супермаркет **/
  Supermarket = 'supermarket',
  /** Театр **/
  Theater = 'theater',
  /** Ветеринарная клиника **/
  VeterinaryClinic = 'veterinaryClinic',
  /** Видеонаблюдение **/
  Video = 'video',
  /** Зоопарк **/
  Zoo = 'zoo',
}

export enum EReadyStatus {
  /** Строится **/
  Building = 'building',
  /** Построен **/
  Built = 'built',
  /** Заморожен **/
  Frozen = 'frozen',
  /** Планируется **/
  Planning = 'planning',
}

export enum ESaleStatus {
  /** Завершены **/
  Closed = 'closed',
  /** Открыты **/
  Opened = 'opened',
  /** Ожидание **/
  Pending = 'pending',
}

export enum ETotalStatus {
  /** Активный **/
  Active = 'active',
  /** Не активный **/
  Inactive = 'inactive',
  /** Ожидание **/
  Pending = 'pending',
  /** Реализован **/
  Sold = 'sold',
}

export enum EVillageClass {
  /** Бизнес **/
  Business = 'business',
  /** Комфорт **/
  Comfort = 'comfort',
  /** Эконом **/
  Economy = 'economy',
  /** Элит **/
  Elite = 'elite',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetVillageForMapResponse): TResponse200;
  400(response: IGetVillageForMapResponseError): TResponse400;
}
